import React, { useState, useEffect, useRef, useCallback } from 'react';
import axios from "axios";
import { APIURL, TZ } from "../../../Global";
import { useParams } from 'react-router-dom';
import './ServiceCatelogue.css';
import { useTranslation } from 'react-i18next';
import SideMenu from './SideMenu';
import { Modal } from 'react-bootstrap';
import ProductCatalogue from './ProductCatalogue';
import { formatDateDDMMYY } from '../../../utils/dateUtils';

const ServiceCatalogue = () => {
  const { t } = useTranslation();
  const [catalogue, setCatalogue] = useState([]);
  const { id } = useParams();
  const [infoShow, setinfoShow] = useState(false);
  const [infoData, setInfoData] = useState('');
  const [loading, setLoading] = useState(false);

  const [selectedCategory, setSelectedCategory] = useState('Services');
  const [selectedSub, setSelectedSub] = useState('');
  const [hasNext1, setHasNext1] = useState(false);
  const [page1, setPage1] = useState(1);
  const [lastPageCalled1, setLastPageCalled1] = useState(1);
  const scrollContainerRef = useRef(null);
  const [searchService, setSearchService] = useState('');
  const [searchVendorId, setSearchVendorId] = useState('');
  const [searchVendorName, setSearchVendorName] = useState('');
  const abortControllerRef = useRef(null);
  const searchTimeoutRef = useRef(null);

  // Load initial data with debouncing
  useEffect(() => {
    if(selectedCategory === "Services"&&selectedSub!==""){
      // Clear previous timeout
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
      
      // Cancel any ongoing request
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }

      // Reset state
      setLastPageCalled1(1);
      setPage1(1);
      setCatalogue([]);

      // Debounce the API call
      searchTimeoutRef.current = setTimeout(() => {
        handleLoad(1);
      }, 300); // 300ms debounce

      return () => {
        if (searchTimeoutRef.current) {
          clearTimeout(searchTimeoutRef.current);
        }
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchService, searchVendorId, searchVendorName, selectedSub, selectedCategory]);

  const handleLoad = useCallback(async (currentPage) => {
    // Cancel any previous request
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    // Create new abort controller for this request
    abortControllerRef.current = new AbortController();

    setLoading(true);
    const tokenString = sessionStorage.getItem('usertoken');
    let str = tokenString.replace(/["]+/g, '');

    try {
      const res = await axios.get(`${APIURL}/api/v1/staff/service-catalogue/?vendor_id=${searchVendorId}&vendor_name=${searchVendorName}&search=${searchService}&category=${selectedSub}&${TZ}&page=${currentPage}`, {
        headers: {
          "Authorization": 'Token ' + str
        },
        signal: abortControllerRef.current.signal
      });

      if (res.data.status === "success") {
        const newData = res.data.message;
        setCatalogue(prevCatalogue => {
          // Check for duplicates before adding
          const existingIds = new Set(prevCatalogue.map(item => item.id));
          const uniqueNewData = newData.filter(item => !existingIds.has(item.id));
          return [...prevCatalogue, ...uniqueNewData];
        });
        setHasNext1(res.data.has_next);
        setPage1(res.data.page + 1);
      }
    } catch (err) {
      if (err.name !== 'CanceledError' && err.name !== 'AbortError') {
        console.error('Error loading catalogue:', err);
      }
    } finally {
      setLoading(false);
    }
  }, [searchService, searchVendorId, searchVendorName, selectedSub]);

  // Scroll handler with debouncing
  const handleScroll = useCallback(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    const { scrollTop, scrollHeight, clientHeight } = scrollContainer;
    const isNearBottom = scrollHeight - (scrollTop + clientHeight) < 50;

    if (isNearBottom && hasNext1 && page1 !== lastPageCalled1 && !loading) {
      setLastPageCalled1(page1);
      handleLoad(page1);
    }
  }, [hasNext1, page1, lastPageCalled1, loading, handleLoad]);

  // Add scroll event listener
  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    scrollContainer.addEventListener('scroll', handleScroll);
    return () => {
      scrollContainer.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  const handleInfoPopUp = (item) => {
    setInfoData(item);
    setinfoShow(true);
  };

  const InfoPopup = (props) => {
    return (
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <h6>{infoData.name?.replace(/_/g, " ").replace(/\b\w/g, char => char.toUpperCase())}</h6>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <fieldset className='field_set'>
              <legend style={{ size: "5" }}>
                <div className="row-of-features">
                  <div className="col-of-features" style={{padding:"1%"}}>
                    <div className='row'>
                     
                        {/* <h6 className='info col-6'>{t('serviceCatalogue.category')}</h6><h6 className='info col-6'>{infoData.category}</h6> */}
                        <h6 className='info col-6'>{t('serviceCatalogue.fee')}</h6><h6 className='info col-6'>{infoData.currency}{" "}{infoData.amount}</h6>
                        <h6 className='info col-6'>{t('serviceCatalogue.description')}</h6><h6 className='info col-6'>{infoData.description}</h6>
                        <h6 className='info col-6'>{t('serviceCatalogue.shortDescription')}</h6><h6 className='info col-6'>{infoData.short_description}</h6>
                      
                     
                    </div>
                  </div>
                </div>
              </legend>
            </fieldset>
          </div>
        </Modal.Body>
      </Modal>
    );
  };

  let display = catalogue.length > 0 ? catalogue.map((data, index) => {
    let id = data.id;
    return (
      <div className="row" key={data.id}
        style={{
          fontSize: "13px",
          cursor: "pointer",
          textAlign: "left",
          borderLeft: "0.4px solid #5f5e5e7a",
          borderBottom: "0.4px solid #5f5e5e7a",
          borderRight: "0.4px solid #5f5e5e7a",
          boxShadow: "2px 2px 7px rgb(0 0 0 / 30%)",
          marginBottom: "0.5%"
        }}>
        <div style={{
          backgroundColor: "#40E0D036",
          padding: "1%",
          borderRight: "0.4px solid #5f5e5e7a",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          textTransform:"capitalize"
        }} className="col-4" title={data.name}>{data.name}</div>

        <div style={{ padding: "1%" }} className="col-2">{formatDateDDMMYY(new Date(data.created_at))}</div>
        <div style={{ padding: "1%",textTransform:"capitalize" }} className="col-2">{data.vendor_name}</div>
        <div style={{ padding: "1%" }} className="col-2">{data.vendor_id}</div>
        {/* <div style={{ padding: "1%" }} className="col-2">{data.tat}</div> */}
        
        <div style={{ padding: "1%", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} className="col-2">
          {data.service_at_home&&data.service_at_lab ?t('serviceCatalogue.home')+"/"+ t('serviceCatalogue.lab') :data.service_at_home&&!data.service_at_lab ? t('serviceCatalogue.home') : t('serviceCatalogue.lab')}
          <svg style={{ float: "right" }} onClick={(e) => { handleInfoPopUp(data) }} xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 1024 1024">
            <path fill="rgba(23, 232, 211, 0.88)" d="M512 64a448 448 0 1 1 0 896.064A448 448 0 0 1 512 64m67.2 275.072c33.28 0 60.288-23.104 60.288-57.344s-27.072-57.344-60.288-57.344c-33.28 0-60.16 23.104-60.16 57.344s26.88 57.344 60.16 57.344M590.912 699.2c0-6.848 2.368-24.64 1.024-34.752l-52.608 60.544c-10.88 11.456-24.512 19.392-30.912 17.28a12.99 12.99 0 0 1-8.256-14.72l87.68-276.992c7.168-35.136-12.544-67.2-54.336-71.296c-44.096 0-108.992 44.736-148.48 101.504c0 6.784-1.28 23.68.064 33.792l52.544-60.608c10.88-11.328 23.552-19.328 29.952-17.152a12.8 12.8 0 0 1 7.808 16.128L388.48 728.576c-10.048 32.256 8.96 63.872 55.04 71.04c67.84 0 107.904-43.648 147.456-100.416z" />
          </svg>
        </div>
      </div>
    );
  }) : null;

  return (
    <div className="catalogue-container" >
      <div className='row' style={{ marginTop: "1%", width: "100%", minHeight: "71vh" }}>
        <div className="col-2">
          <SideMenu
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            selectedSub={selectedSub}
            setSelectedSub={setSelectedSub}
          />
        </div>

        {selectedCategory === "Services" ? <div ref={scrollContainerRef}
    style={{
      maxHeight: '71vh',
      overflowY: 'auto',
      position: 'relative',
      paddingRight: '10px', display: 'flex'
    }}  className="col-10" >
          <div className="container">
            <div className='row'>
              <div className="col-12">
                <div className="search-div row">
                  <div className="col-5">
                    <input
                      type="text"
                      className="search-clinics"
                      placeholder={t('serviceCatalogue.searchByService')}
                      value={searchService}
                      onChange={(e) => setSearchService(e.target.value)}
                    />
                  </div>
                  <div className="col-3">
                    <input
                      type="text"
                      className="search-clinics"
                      placeholder={t('serviceCatalogue.searchByVendorId')}
                      value={searchVendorId}
                      onChange={(e) => setSearchVendorId(e.target.value)}
                    />
                  </div>
                  <div className="col-4">
                    <input
                      type="text"
                      className="search-clinics"
                      placeholder={t('serviceCatalogue.searchByVendorName')}
                      value={searchVendorName}
                      onChange={(e) => setSearchVendorName(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              
            </div>

            <br />

            <div className=""  style={{ margin: "auto" }}>
              <div className="container">
                <div

                 
                  className="test-reports-display-list"
                
                >
                 
                    <>
                      <div className="row" style={{
                        backgroundColor: "#01C9C9",
                        color: "white",
                        textAlign: "left",
                        padding: "1%",
                        borderRadius: "5px 5px 0px 0px",
                        boxShadow: "2px 2px 7px rgb(0 0 0 / 30%)",
                        marginBottom: "0.5%",
                        fontSize: "12px",
                        position: 'sticky',
                        top: 0,
                        zIndex: 1
                      }}>
                        <div className="col-4"><b>{t('serviceCatalogue.services')}</b></div>
                        <div className="col-2"><b>{t('serviceCatalogue.createdAt')}</b></div>
                        <div className="col-2"><b>{t('serviceCatalogue.vendor')}</b></div>
                        <div className="col-2"><b>{t('serviceCatalogue.id')}</b></div>
                        {/* <div className="col-2"><b>{t('serviceCatalogue.duration')}</b></div> */}
                        <div className="col-2"><b>{t('serviceCatalogue.serviceMode')}</b></div>
                      </div>
                      {display}
                      {loading && (
                        <div className="text-center py-3">
                          <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">{t('serviceCatalogue.loading')}</span>
                          </div>
                        </div>
                      )}
                    </>
                </div>
              </div>
            </div>
          </div>
        </div>:<ProductCatalogue selectedCategory={selectedCategory} selectedSub={selectedSub}/>}
      </div>

      {infoShow ?
        <InfoPopup
          show={infoShow}
          onHide={() => {
            setinfoShow(false);
          }}
        /> : ''
      }
    </div>
  );
};

export default ServiceCatalogue;